import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'walk-action',
    templateUrl:'walkableAction.html'
})
export class WalkActionComponent implements OnInit{

  public linkForm: FormGroup;

  public constructor(public translate: TranslationService,public _appData : AppDataService,private fb : FormBuilder, private _companyService : CompanyService) {
    this.linkForm = this.fb.group({
      linkParam: false,
    });
  }
  public saveData(){
    let linkParam = this.linkForm.controls['linkParam'].value;
    if (!this._appData.action){
      this._appData.action={kind:'walkArea',param:{}}
    }
    this._appData.action.param.muted=linkParam
    document.getElementById('trigger-action-done').click();
  }
  public reload(){
    let action = this._appData.action;
    if (action.param && action.param.muted!=null) {
      this.linkForm = this.fb.group({
        linkParam: action.param.muted
      })
    }    
  }
    public ngOnInit(): any {
    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/walkableAction.ts